import { Coordinate, Project, VideoColorFinderFlight } from "@nova/protobuf"
import {
    booleanValidator,
    createLayerValidator,
    demoIdValidators,
    idValidators,
    UnionToTuple,
    updateLayerValidator,
} from "../util"
import { dateAsNumber } from "../../util"
import { createNewLayerFractionalIndex } from "../../util/fractional_indexing"
import { isValidLonLat } from "@nova/calculate-geospatial"

export const createVideoColorFinderFlightValidator = createLayerValidator(VideoColorFinderFlight, {
    isCreatedFromVideo: { validators: booleanValidator("isCreatedFromVideo") },
})

export const updateVideoColorFinderFlightValidator = updateLayerValidator(VideoColorFinderFlight, {
    referenceVideoId: { validators: idValidators },
    demoId: {
        validators: demoIdValidators,
    },
    startingPosition: {
        validators: [
            {
                validator: (coordinate: Coordinate) => isValidLonLat(coordinate),
                error: "Coordinates contain invalid values",
            },
        ],
    },
})

export const getDefaultVideoColorFinderFlightCreateArgs = (
    project: Project,
    inParentId?: string
) => ({
    visible: true,
    createdAt: dateAsNumber(),
    index: createNewLayerFractionalIndex(project, 0, inParentId),
    // parentId would never got autopopulated
    parentId: undefined,
})

export type CreateVideoColorFinderFlightArgs = UnionToTuple<
    keyof typeof createVideoColorFinderFlightValidator
>
export type UpdateVideoColorFinderFlightArgs = UnionToTuple<
    keyof typeof updateVideoColorFinderFlightValidator
>
